module.exports = __webpack_public_path__ + "static/img/s53.2693f402.png";